import Vue from "vue";
import Vuex from "vuex";
import service from "../../services/cuentasCorrientes/currentAccounts";
import accounts from "@/models/cuentasCorrientes/accounts";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    service: new service(),
    paddingNav: "10px",
    accounts: [],
    new: {},
    edit: {},
    editRelation: {},
    itemDelete: null,
    openDelete: false,
    openRelation: false,
    openFormRelation: false,
    modeFormRelation: "",
    mode: null,
    paddingNav: "10px",
    dateLiq: null,
    hours: "",
    movements: [],
  },

  mutations: {
    setPaddingNav(state, data) {
      state.paddingNav = data;
    },
    setOpen(state, data) {
      state.open = data;
    },
    setOpenDelete(state, data) {
      state.openDelete = data;
    },
    setItemDelete(state, data) {
      state.itemDelete = data;
    },
    setMode(state, data) {
      state.mode = data;
    },
    setAccounts(state, data) {
      state.accounts = data;
    },
    setNew(state, data) {
      state.new = data;
    },
    setEdit(state, data) {
      state.edit = data;
    },
    setShowCard(state, data) {
      state.showCard = data;
    },
    setShowTable(state, data) {
      state.showTable = data;
    },
    setOpenRelation(state, data) {
      state.openRelation = data;
    },
    setOpenFormRelation(state, data) {
      state.openFormRelation = data;
    },
    setModeFormRelation(state, data) {
      state.modeFormRelation = data;
    },
    setEditRelation(state, data) {
      state.editRelation = data;
    },
    setDateLiq(state, data) {
      state.dateLiq = data;
    },
    setHours(state, data) {
      state.hours = data;
    },
    setMovements(state, data) {
      state.movements = data;
    },
  },
  actions: {
    async getAccounts(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getAccounts();
          state.commit("setAccounts", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },

    async add(state) {
      try {
        const newItem = await state.state.service.add(state.state.new);
        const updatedItems = [newItem, ...state.state.accounts];
        state.commit("setAccounts", updatedItems);
        return true;
      } catch (error) {
        throw error;
      }
    },

    async delete(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service.delete(state.state.itemDelete);
          let options = state.state.accounts;

          options = options.filter((option) => {
            return option.accountId != state.state.itemDelete;
          });

          state.commit("setAccounts", options);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },

    async edit(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service.edit(state.state.edit);

          const updatedItem = state.state.edit;

          let options = state.state.accounts.map((option) => {
            if (option.accountId !== updatedItem.accountId) {
              return option;
            }
            return accounts.fromJson({
              cuentaId: updatedItem.accountId,
              nombre: updatedItem.name || option.name,
              descripcion: updatedItem.description || option.description,
              unidad: updatedItem.unit || option.unit,
            });
          });

          state.commit("setAccounts", options);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },

    async getAccountId({ state, commit }, accountId) {
      try {
        const data = await state.service.getAccountId(accountId);

        commit("setEdit", data);
        return true;
      } catch (error) {
        throw error;
      }
    },

    //conceptos
    async addConcept(state) {
      try {
        const response = await state.state.service.addConceptToAccount(
          state.state.new
        );

        const data = await state.state.service.getAccountId(
          response.data.cuentaId
        );

        state.commit("setEdit", data);
        return true;
      } catch (error) {
        throw error;
      }
    },

    async deleteConcept(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .deleteConceptToAccount(state.state.itemDelete)
            .then(() => {
              let options = state.state.edit.concepts;

              options = options.filter((option) => {
                return option.conceptoId !== state.state.itemDelete.conceptId;
              });

              let edit = { ...state.state.edit };
              edit.concepts = options;

              state.commit("setEdit", edit);
              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },

    async editConcept(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service.editConceptToAccount(
            state.state.editRelation
          );

          const data = await state.state.service.getAccountId(
            state.state.editRelation.accountId
          );

          state.commit("setEdit", data);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },

    //empleados
    async addEmployees(state) {
      try {
        const response = await state.state.service.addEmployeesToAccount(
          state.state.new
        );

        const data = await state.state.service.getAccountId(
          response.data.cuentaId
        );

        state.commit("setEdit", data);
        return true;
      } catch (error) {
        throw error;
      }
    },

    async editEmployees(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service.editEmployeesToAccount(
            state.state.editRelation
          );

          const data = await state.state.service.getAccountId(
            state.state.editRelation.accountId
          );

          state.commit("setEdit", data);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },

    async deleteEmployees(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .deleteEmployeesToAccount(state.state.itemDelete)
            .then(() => {
              let options = state.state.edit.employees;

              options = options.filter((option) => {
                return option.empId !== state.state.itemDelete.empId;
              });

              let edit = { ...state.state.edit };
              edit.employees = options;

              state.commit("setEdit", edit);
              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },

    async addMovement(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .addMovementToAccount(state.state.editRelation)
            .then(() => {
              state
                .dispatch("getAccountId", state.state.editRelation.accountId)
                .then(() => {
                  resolve(true);
                });
            });
        } catch (error) {
          reject(error);
        }
      });
    },

    async getMovements({ state, commit }, payload) {
      try {
        const data = await state.service.getMovements(payload);
        commit("setMovements", data);
        return true;
      } catch (error) {
        throw error;
      }
    },

    async initializeMassive(state) {
      try {
        const response = await state.state.service.initializeMassive(
          state.state.new
        );
        return response;
      } catch (error) {
        throw error;
      }
    },
  },
});
